/**
 * ThemeToggle — the sun/moon button in the appbar. One per page shell;
 * flips the whole app between light and dark (see src/theme.ts).
 */
import React from 'react';
import { useAjoTheme, toggleTheme } from '../ajoTheme';

export default function ThemeToggle() {
  const theme = useAjoTheme();
  const dark = theme === 'dark';
  return (
    <button
      type="button"
      className="appbar-theme-toggle"
      onClick={toggleTheme}
      title={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={dark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={dark}
    >
      <svg width="15" height="15" viewBox="0 0 16 16" aria-hidden="true">
        <path
          d={dark
            ? 'M8 2v1.5M8 12.5V14M2 8h1.5M12.5 8H14M3.8 3.8l1 1M11.2 11.2l1 1M12.2 3.8l-1 1M4.8 11.2l-1 1M8 5.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6z'
            : 'M13.2 9.3A5.6 5.6 0 0 1 6.7 2.8 5.6 5.6 0 1 0 13.2 9.3z'}
          stroke="currentColor" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
